import React, { useState, useEffect } from 'react';

const API_URL = `${process.env.REACT_APP_API_URL}/api/hiring-documents`;

function HiringAgreementView() {
  const [doc, setDoc] = useState({ notes: [] });
  const [loading, setLoading] = useState(true);
  const [hoveredNote, setHoveredNote] = useState(null);

  useEffect(() => {
    fetch(API_URL)
      .then(res => res.json())
      .then(json => {
        if (json.success && json.data) setDoc(json.data);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = () => {
    if (doc.fileURL) {
      const link = document.createElement('a');
      link.href = doc.fileURL;
      link.download = doc.fileName || 'Hiring_Agreement.pdf';
      link.click();
    }
  };

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
        color: '#C7B381',
        fontSize: '2rem',
        fontWeight: '300',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        Loading agreement...
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(to bottom, #0F1419, #1A1F2E)',
      color: '#E8E8E8',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{ padding: '6rem 2rem 8rem', maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '6rem' }}>
          <div style={{
            display: 'inline-block',
            color: '#C7B381',
            fontSize: '0.8rem',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: '1.5rem',
            fontWeight: '500'
          }}>
            Terms & Conditions
          </div>
          <h1 style={{ 
            fontSize: 'clamp(2.5rem, 6vw, 4rem)', 
            fontWeight: '300', 
            marginBottom: '1.5rem',
            color: '#FFFFFF',
            letterSpacing: '-0.01em'
          }}>
            Vehicle <span style={{ fontWeight: '600', color: '#C7B381' }}>Hiring Agreement</span>
          </h1>
          <p style={{ 
            fontSize: 'clamp(1rem, 2vw, 1.2rem)', 
            color: '#B8B8B8', 
            maxWidth: '700px', 
            margin: '0 auto',
            lineHeight: '1.8',
            fontWeight: '300',
            padding: '0 1rem'
          }}>
            Please read the agreement carefully before proceeding with your booking.
          </p>
        </div>

        {/* Document Section */}
        <div style={{ 
          background: 'rgba(15, 20, 25, 0.6)',
          border: '1px solid rgba(199, 179, 129, 0.15)',
          borderRadius: '16px',
          padding: 'clamp(1.5rem, 3vw, 2.5rem)', 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)', 
          marginBottom: '4rem',
          transition: 'all 0.3s ease'
        }}>
          <h2 style={{ 
            fontSize: 'clamp(1.3rem, 2.5vw, 1.8rem)', 
            marginBottom: '2rem', 
            color: '#C7B381', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.8rem',
            flexWrap: 'wrap',
            fontWeight: '400',
            letterSpacing: '-0.01em'
          }}>
            <span style={{ fontSize: '1.8rem' }}>📄</span> Hiring Agreement Document
          </h2>

          {doc.fileURL ? (
            <div>
              <div style={{ 
                border: '1px solid rgba(199, 179, 129, 0.2)', 
                borderRadius: '12px', 
                overflow: 'hidden', 
                marginBottom: '2rem',
                boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
                background: '#fff'
              }}>
                <iframe
                  src={doc.fileURL}
                  title="Hiring Agreement"
                  style={{ 
                    width: '100%', 
                    height: 'clamp(400px, 60vh, 600px)', 
                    border: 'none',
                    display: 'block'
                  }}
                />
              </div>

              <div style={{ textAlign: 'center' }}>
                <button
                  onClick={handleDownload}
                  style={{
                    padding: 'clamp(0.8rem, 2vw, 1rem) clamp(2rem, 4vw, 3rem)',
                    background: '#C7B381',
                    color: '#0F1419',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 4px 15px rgba(199, 179, 129, 0.3)',
                    transition: 'all 0.3s ease',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.8rem',
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.background = '#D4C599';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.background = '#C7B381';
                  }}
                >
                  <span style={{ fontSize: '1.2em' }}>⬇️</span> 
                  <span>Download Agreement</span>
                </button>
                {doc.fileName && (
                  <div style={{ 
                    marginTop: '1rem',
                    fontSize: '0.9rem', 
                    color: '#888',
                    letterSpacing: '0.05em'
                  }}>
                    {doc.fileName}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: 'clamp(3rem, 6vw, 5rem)',
              background: 'rgba(199, 179, 129, 0.03)',
              borderRadius: '12px',
              border: '1px dashed rgba(199, 179, 129, 0.2)'
            }}>
              <div style={{ 
                fontSize: '3rem',
                marginBottom: '1.5rem',
                opacity: 0.3
              }}>
                📭
              </div>
              <p style={{ 
                color: '#888', 
                fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                marginBottom: '0.5rem'
              }}>
                No agreement document available at this time.
              </p>
              <p style={{ 
                color: '#666', 
                fontSize: 'clamp(0.9rem, 1.5vw, 1rem)'
              }}>
                Please check back later or contact support.
              </p>
            </div>
          )}
        </div>

        {/* Notes Section */}
        {doc.notes && doc.notes.length > 0 && (
          <div style={{ 
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            padding: 'clamp(1.5rem, 3vw, 2.5rem)', 
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)' 
          }}>
            <h2 style={{ 
              fontSize: 'clamp(1.3rem, 2.5vw, 1.8rem)', 
              marginBottom: '2.5rem', 
              color: '#C7B381',
              display: 'flex',
              alignItems: 'center',
              gap: '0.8rem',
              fontWeight: '400',
              letterSpacing: '-0.01em'
            }}>
              <span style={{ fontSize: '1.8rem' }}>📝</span> Important Information
            </h2>

            <div style={{ 
              display: 'grid', 
              gap: 'clamp(1rem, 2vw, 1.5rem)',
              gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 350px), 1fr))'
            }}>
              {doc.notes.sort((a, b) => a.orderNumber - b.orderNumber).map((note, index) => (
                <div 
                  key={note._id || index} 
                  onMouseEnter={() => setHoveredNote(index)}
                  onMouseLeave={() => setHoveredNote(null)}
                  style={{
                    background: hoveredNote === index 
                      ? 'rgba(199, 179, 129, 0.08)' 
                      : 'rgba(199, 179, 129, 0.05)',
                    border: hoveredNote === index
                      ? '1px solid rgba(199, 179, 129, 0.4)'
                      : '1px solid rgba(199, 179, 129, 0.2)',
                    borderLeft: '4px solid #C7B381',
                    padding: 'clamp(1.2rem, 2.5vw, 1.8rem)',
                    borderRadius: '12px',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: hoveredNote === index 
                      ? '0 12px 28px rgba(0,0,0,0.4)' 
                      : '0 4px 12px rgba(0,0,0,0.2)',
                    transform: hoveredNote === index ? 'translateX(8px)' : 'translateX(0)',
                    cursor: 'default'
                  }}
                >
                  <h3 style={{ 
                    fontSize: 'clamp(1.1rem, 2vw, 1.4rem)', 
                    fontWeight: '500', 
                    marginBottom: '0.8rem', 
                    color: '#FFFFFF',
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '0.6rem',
                    letterSpacing: '-0.01em'
                  }}>
                    <span style={{ 
                      color: '#C7B381',
                      fontSize: '1.1em',
                      fontWeight: '600',
                      minWidth: '2rem'
                    }}>
                      {note.orderNumber}.
                    </span>
                    <span>{note.noteTitle}</span>
                  </h3>
                  <p style={{ 
                    fontSize: 'clamp(0.95rem, 1.8vw, 1.05rem)', 
                    lineHeight: '1.8', 
                    color: '#B8B8B8',
                    margin: 0,
                    paddingLeft: '2.6rem'
                  }}>
                    {note.noteBody}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Empty State for Notes */}
        {(!doc.notes || doc.notes.length === 0) && doc.fileURL && (
          <div style={{ 
            textAlign: 'center', 
            padding: 'clamp(3rem, 6vw, 5rem)',
            color: '#888',
            background: 'rgba(15, 20, 25, 0.6)',
            border: '1px solid rgba(199, 179, 129, 0.15)',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.3 }}>💡</div>
            <p style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', color: '#888' }}>
              No additional notes at this time
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default HiringAgreementView;